export default '/build/73e3d3cc.svg'